<template>
  <SidebarProvider>
    <AppSidebar />
    <div class="flex flex-1 flex-col min-w-0 overflow-x-hidden h-screen">
      <header
        class="sticky top-0 z-10 flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 bg-sidebar border-b border-border"
      >
        <div class="flex items-center gap-2 px-4">
          <SidebarTrigger class="-ml-1" />
          <Separator orientation="vertical" class="mr-2 h-4" />
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>
                  {{ pageTitle }}
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <div class="ml-auto flex items-center gap-4 px-4">
          <span class="select-none">Admin Portal</span>
          <DropdownMenu>
            <DropdownMenuTrigger as-child>
              <Button variant="outline" size="icon">
                <component :is="currentModeIcon" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem
                v-for="option in modeOptions"
                :key="option.value"
                class="cursor-pointer"
                @click="mode = option.value"
              >
                <component :is="option.icon" class="mr-2 size-4" />
                {{ $t(option.labelKey) }}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </header>
      <SidebarInset class="flex-1 overflow-y-auto">
        <div class="flex h-full flex-1 flex-col overflow-y-auto md:border-l md:border-border">
          <div class="pt-4 pb-8 px-4">
            <RouterView />
          </div>
        </div>
      </SidebarInset>
    </div>
  </SidebarProvider>
</template>

<script setup lang="ts">
import AppSidebar from '@/components/AppSidebar.vue'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/components/ui/breadcrumb'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Separator } from '@/components/ui/separator'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar'
import { usePageTitle } from '@/hooks/usePageTitle'
import { useColorMode } from '@vueuse/core'
import { Monitor, Moon, Sun } from 'lucide-vue-next'
import { computed } from 'vue'

const { pageTitle } = usePageTitle()

// Dark mode toggle
const mode = useColorMode({
  emitAuto: true,
})

const modeOptions = [
  { value: 'light' as const, icon: Sun, labelKey: 'common.light' },
  { value: 'dark' as const, icon: Moon, labelKey: 'common.dark' },
  { value: 'auto' as const, icon: Monitor, labelKey: 'common.auto' },
]

const currentModeIcon = computed(() => {
  return modeOptions.find((option) => option.value === mode.value)?.icon ?? Monitor
})
</script>
